import { Button, Card, FormControl, FormControlLabel, Grid, Input, InputLabel, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import { FileCopy } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useRef, useState } from "react";
import { Col, FormLabel, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { cekCookies } from "../../../../../actions";
import akmApi from "../../../../../apis/akmApi";
import { URL_AKM } from "../../../../../config";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";

const ListProdi = (props) => {
    const [isFetching, setisFetching] = useState(false);
    const [isOpen, setisOpen] = useState(false);
    const [isOpenImport, setisOpenImport] = useState(false);
    const [listProdi, setlistProdi] = useState([]);
    const [id, setId] = useState(null);
    const [val, setVal] = useState([]);

    const [search, Setsearch] = useState(null);

    const [kodeProdi, setkodeProdi] = useState("");
    const [namaProdiPtn, setnamaProdiPtn] = useState(null);
    const [namaProdi, setnamaProdi] = useState(null);
    const [importFile, setimportFile] = useState(null);
    const [listType, SetlistType] = useState(null);
    const [jumlahPeminat, setjumlahPeminat] = useState(null);
    const [dtLama, setdtLama] = useState(null);
    const [dtBaru, setdtBaru] = useState(null);
    const [poin, setpoin] = useState(null);
    const [indexKeketatan, setindexKeketatan] = useState(null);
    const [nilaiNasional, setnilaiNasional] = useState(null);
    const [nilaiRataanMinimum, setnilaiRataanMinimum] = useState(null);
    const [nilaiRataan, setnilaiRataan] = useState(null);
    const [indexPersaingan, setindexPersaingan] = useState(null);
    const [kelompokProdi, setkelompokProdi] = useState(null);
    const [kategoriPTN, setkategoriPTN] = useState(null);
    const [mpkp1, setmpkp1] = useState(null);
    const [mpkp2, setmpkp2] = useState(null);
    const [mpkpAgama1, setmpkpAgama1] = useState(null);
    const [mpkpAgama2, setmpkpAgama2] = useState(null);
    const [mpkpAkp1, setmpkpAkp1] = useState(null);
    const [mpkpAkp2, setmpkpAkp2] = useState(null);
    const [mpkpAsesmen1, setmpkpAsesmen1] = useState(null);
    const [mpkpAsesmen2, setmpkpAsesmen2] = useState(null);
    const [mpkpBahasa1, setmpkpBahasa1] = useState(null);
    const [mpkpBahasa2, setmpkpBahasa2] = useState(null);
    const [mpkpIpa1, setmpkpIpa1] = useState(null);
    const [mpkpIpa2, setmpkpIpa2] = useState(null);
    const [mpkpIps1, setmpkpIps1] = useState(null);
    const [mpkpIps2, setmpkpIps2] = useState(null);
    const [mpkpPsp1, setmpkpPsp1] = useState(null);
    const [mpkpPsp2, setmpkpPsp2] = useState(null);
    const [mpkpTkp1, setmpkpTkp1] = useState(null);
    const [mpkpTkp2, setmpkpTkp2] = useState(null);
    const [mpks1, setmpks1] = useState(null);
    const [mpks2, setmpks2] = useState(null);

    const [pages, setpage] = useState(0);
    const [size, setsize] = useState(10);
    const [totalPages, settotalPages] = useState(0);
    const [numberOfElements, setnumberOfElements] = useState(0);
    const [totalElements, settotalElements] = useState(0);
    const [listError, setListError] = useState("");
    const listRequest = useRef(0);

    useEffect(() => {
        let active = true;
        const getDatas = async () => {
            await props.cekCookies();
            if (active && props.account !== null) {
                setpage(0);
                fetchUniqueListProdi(size, 0, listType, search);
            }
        };

        getDatas();
        return () => { active = false; listRequest.current += 1; };
    }, []);

    const fetchUniqueListProdi = async (size, pages, listType, search) => {
        const request = ++listRequest.current;
        setisFetching(true);
        setListError("");
        try {
            const respons = await akmApi.get(URL_AKM.LIST_PRODI, {
                params: { size, page: pages, type: listType, nameSearch: search },
            });
            if (request === listRequest.current) {
                if (!respons || !respons.data || !respons.data.data || !Array.isArray(respons.data.data.content)) {
                    throw new Error("Daftar prodi tidak tersedia.");
                }
                const responseAPI = respons.data.data;
                setlistProdi(responseAPI.content);
                settotalPages(responseAPI.totalPages);
                setnumberOfElements(responseAPI.numberOfElements);
                settotalElements(responseAPI.totalElements);
            }
        } catch (error) {
            if (request === listRequest.current) {
                setlistProdi([]);
                settotalPages(0);
                setnumberOfElements(0);
                settotalElements(0);
                setListError("Daftar prodi gagal dimuat. Silakan coba lagi.");
            }
        } finally {
            if (request === listRequest.current) setisFetching(false);
        }
    };

    const handleSelectType = async (e) => {
        SetlistType(e.target.value);
        setpage(0);
        fetchUniqueListProdi(size, 0, e.target.value, search);
    };

    const handleOpenModal = async () => {
        setisOpen(true);
    };

    const handleCloseModal = async () => {
        setisOpen(false);
    };

    const handleOpenModalImport = async () => {
        setisOpenImport(true);
    };

    const handleCloseModalImport = async () => {
        setisOpenImport(false);
    };

    const handleChangePage = async (e, newPage) => {
        setpage(newPage);

        fetchUniqueListProdi(size, newPage, listType, search);
    };

    const handleChangeRowsPerPage = (e) => {
        setpage(0);
        const nextSize = Number(e.target.value);
        setsize(nextSize);

        fetchUniqueListProdi(nextSize, 0, listType, search);
    };

    const handleChangeNamePp = async (e) => {
        Setsearch(e.target.value);
        setpage(0);
        fetchUniqueListProdi(size, 0, listType, e.target.value);
    };

    const handleThrowPaketProgram = async (data) => {
        console.log("====================================");
        console.log(data);
        console.log("====================================");

        // const respons = await akmApi.get(URL_AKM.LIST_PRODI, { params: { kodeProdi: id } });

        // const responseAPI = respons.data.data.content[0];

        setisOpen(true);

        setkodeProdi(data.idKodeProdi);
        setnamaProdiPtn(data.namaPerguruanTinggi);
        setnamaProdi(data.namaProdi);
        setjumlahPeminat(data.programStudi.jumlahPeminat);
        setdtLama(data.programStudi.dayaTampungLama);
        setdtBaru(data.programStudi.dayaTampungBaru);
        setpoin(data.programStudi.poin);
        setindexKeketatan(data.programStudi.indexKeketatan);
        setnilaiNasional(data.programStudi.nilaiNasional);
        setnilaiRataanMinimum(data.programStudi.nilaiRataanMinimum);
        setindexPersaingan(data.programStudi.indeksPersaingan);
        setkelompokProdi(data.programStudi.kelompokProdi);
        setkategoriPTN(data.programStudi.kategoriPtn);

        if (listType === "SNMPTN") {
            setnilaiRataan(data.programStudi.nilaiRataan);
            setmpkpAgama1(data.programStudi.mpkpAgama !== null ? data.programStudi.mpkpAgama.split("|")[0] : "");
            setmpkpAgama2(data.programStudi.mpkpAgama !== null ? (data.programStudi.mpkpAgama.split("|").length > 1 ? data.programStudi.mpkpAgama.split("|")[1] : "") : "");
            setmpkpAkp1(data.programStudi.mpkpAkp !== null ? data.programStudi.mpkpAkp.split("|")[0] : "");
            setmpkpAkp2(data.programStudi.mpkpAkp !== null ? (data.programStudi.mpkpAkp.split("|").length > 1 ? data.programStudi.mpkpAkp.split("|")[1] : "") : "");
            setmpkpAsesmen1(data.programStudi.mpkpAsesmen !== null ? data.programStudi.mpkpAsesmen.split("|")[0] : "");
            setmpkpAsesmen2(data.programStudi.mpkpAsesmen !== null ? (data.programStudi.mpkpAsesmen.split("|").length > 1 ? data.programStudi.mpkpAsesmen.split("|")[1] : "") : "");
            setmpkpBahasa1(data.programStudi.mpkpBahasa !== null ? data.programStudi.mpkpBahasa.split("|")[0] : "");
            setmpkpBahasa2(data.programStudi.mpkpBahasa !== null ? (data.programStudi.mpkpBahasa.split("|").length > 1 ? data.programStudi.mpkpBahasa.split("|")[1] : "") : "");
            setmpkpIpa1(data.programStudi.mpkpIpa !== null ? data.programStudi.mpkpIpa.split("|")[0] : "");
            setmpkpIpa2(data.programStudi.mpkpIpa !== null ? (data.programStudi.mpkpIpa.split("|").length > 1 ? data.programStudi.mpkpIpa.split("|")[1] : "") : "");
            setmpkpIps1(data.programStudi.mpkpIps !== null ? data.programStudi.mpkpIps.split("|")[0] : "");
            setmpkpIps2(data.programStudi.mpkpIps !== null ? (data.programStudi.mpkpIps.split("|").length > 1 ? data.programStudi.mpkpIps.split("|")[1] : "") : "");
            setmpkpPsp1(data.programStudi.mpkpPsp !== null ? data.programStudi.mpkpPsp.split("|")[0] : "");
            setmpkpPsp2(data.programStudi.mpkpPsp !== null ? (data.programStudi.mpkpPsp.split("|").length > 1 ? data.programStudi.mpkpPsp.split("|")[1] : "") : "");
            setmpkpTkp1(data.programStudi.mpkpTkp !== null ? data.programStudi.mpkpTkp.split("|")[0] : "");
            setmpkpTkp2(data.programStudi.mpkpTkp !== null ? (data.programStudi.mpkpTkp.split("|").length > 1 ? data.programStudi.mpkpTkp.split("|")[1] : "") : "");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let response = null;
        let data = null;

        if (listType === "SNMPTN") {
            data = {
                idKodeProdi: kodeProdi,
                jumlahPeminat: jumlahPeminat,
                dayaTampungLama: dtLama,
                dayaTampungBaru: dtBaru,
                poin: poin,
                indexKeketatan: indexKeketatan,
                nilaiNasional: nilaiNasional,
                nilaiRataanMinimum: nilaiRataanMinimum,
                nilaiRataan: nilaiRataan,
                indeksPersaingan: indexPersaingan,
                kelompokProdi: kelompokProdi,
                kategoriPtn: kategoriPTN,
                mpkpIpa: mpkpIpa1 !== "" && mpkpIpa2 !== "" ? mpkpIpa1 + "|" + mpkpIpa2 : mpkpIpa1 !== "" && mpkpIpa2 === "" ? mpkpIpa1 : mpkpIpa1 === "" && mpkpIpa2 !== "" ? mpkpIpa2 : "",
                mpkpIps: mpkpIps1 !== "" && mpkpIps2 !== "" ? mpkpIps1 + "|" + mpkpIps2 : mpkpIps1 !== "" && mpkpIps2 === "" ? mpkpIps1 : mpkpIps1 === "" && mpkpIps2 !== "" ? mpkpIps2 : "",
                mpkpBahasa: mpkpBahasa1 !== "" && mpkpBahasa2 !== "" ? mpkpBahasa1 + "|" + mpkpBahasa2 : mpkpBahasa1 !== "" && mpkpBahasa2 === "" ? mpkpBahasa1 : mpkpBahasa1 === "" && mpkpBahasa2 !== "" ? mpkpBahasa2 : "",
                mpkpAgama: mpkpAgama1 !== "" && mpkpAgama2 !== "" ? mpkpAgama1 + "|" + mpkpAgama2 : mpkpAgama1 !== "" && mpkpAgama2 === "" ? mpkpAgama1 : mpkpAgama1 === "" && mpkpAgama2 !== "" ? mpkpAgama2 : "",
                mpkpTkp: mpkpTkp1 !== "" && mpkpTkp2 !== "" ? mpkpTkp1 + "|" + mpkpTkp2 : mpkpTkp1 !== "" && mpkpTkp2 === "" ? mpkpTkp1 : mpkpTkp1 === "" && mpkpTkp2 !== "" ? mpkpTkp2 : "",
                mpkpAkp: mpkpAkp1 !== "" && mpkpAkp2 !== "" ? mpkpAkp1 + "|" + mpkpAkp2 : mpkpAkp1 !== "" && mpkpAkp2 === "" ? mpkpAkp1 : mpkpAkp1 === "" && mpkpAkp2 !== "" ? mpkpAkp2 : "",
                mpkpPsp: mpkpPsp1 !== "" && mpkpPsp2 !== "" ? mpkpPsp1 + "|" + mpkpPsp2 : mpkpPsp1 !== "" && mpkpPsp2 === "" ? mpkpPsp1 : mpkpPsp1 === "" && mpkpPsp2 !== "" ? mpkpPsp2 : "",
                mpkpAsesmen: mpkpAsesmen1 !== "" && mpkpAsesmen2 !== "" ? mpkpAsesmen1 + "|" + mpkpAsesmen2 : mpkpAsesmen1 !== "" && mpkpAsesmen2 === "" ? mpkpAsesmen1 : mpkpAsesmen1 === "" && mpkpAsesmen2 !== "" ? mpkpAsesmen2 : "",
            };

            response = await akmApi.put(URL_AKM.UPLDATE_LIST_PRODI_SNMPTN, data).catch(function (error) {
                setlistProdi([]);
            });

            fetchUniqueListProdi("SNMPTN");
            console.log("response SNMPTN => ", response);
        } else {
            data = {
                idKodeProdi: kodeProdi,
                jumlahPeminat: jumlahPeminat,
                dayaTampungLama: dtLama,
                dayaTampungBaru: dtBaru,
                poin: poin,
                indexKeketatan: indexKeketatan,
                nilaiNasional: nilaiNasional,
                nilaiRataanMinimum: nilaiRataanMinimum,
                indeksPersaingan: indexPersaingan,
                kelompokProdi: kelompokProdi,
                kategoriPtn: kategoriPTN,
            };

            response = await akmApi.put(URL_AKM.UPLDATE_LIST_PRODI_SBMPTN, data).catch(function (error) {
                setlistProdi([]);
            });

            fetchUniqueListProdi("SBMPTN");
            console.log("response SBMPTN => ", response);
        }

        handleCloseModal();
    };

    const onFileChange = (event) => {
        setimportFile(event.target.files[0]);
    };

    const handleSubmitFile = async (event) => {
        setisFetching(true);
        event.preventDefault();

        if (importFile !== "" && importFile.size < 1000000) {
            let data = new FormData();
            data.append("file", importFile);
            const response = await akmApi.post(URL_AKM.LIST_PRODI + "/import", data).catch(function (error) {
                console.log("====================================");
                console.log(error);
                console.log("====================================");
            });

            console.log("response submit", response);
            if (response) {
                alert("File Dokumen sukses diupload !!");
                handleCloseModalImport();
                document.getElementById("file").value = "";
                fetchUniqueListProdi(kodeProdi);
                setisFetching(false);
            }
        } else {
            alert("File Dokumen harus < 1Mb ..!!");
            setisFetching(false);
        }
    };

    const FunlistProdi = () => (
        <>
            <Row style={{ marginTop: 25 }}>
                <Col>
                    {listType === "SNMPTN" ? (
                        <Row>
                            <Col sm={12}>
                                <Card style={{ padding: 20, backgroundColor: "#1a237e", color: "#fff" }}>List Prodi {listType}</Card>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col sm={12}>
                                <Card style={{ padding: 20, backgroundColor: "#b71c1c", color: "#fff" }}>List Prodi {listType}</Card>
                            </Col>
                        </Row>
                    )}
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Kode Prodi</TableCell>
                                    <TableCell align="left">Nama Perguruan Tinggi</TableCell>
                                    <TableCell align="left">Nama Program Studi</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listProdi.length > 0 &&
                                    listProdi.map((list, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{list.idKodeProdi}</TableCell>
                                            <TableCell>{list.namaPerguruanTinggi}</TableCell>
                                            <TableCell>{list.namaProdi}</TableCell>
                                            <TableCell align="center">
                                                {
                                                    <div className="button-group">
                                                        <button className="btn btn-outline-info btn-sm" onClick={() => handleThrowPaketProgram(list)}>
                                                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                        <TablePagination component="div" count={totalElements} page={pages} onPageChange={handleChangePage} rowsPerPage={size} onChangeRowsPerPage={handleChangeRowsPerPage} />
                    </TableContainer>
                </Col>
            </Row>
        </>
    );

    return (
        <div className="wrapper">
            <LoaderModal isFetching={isFetching} />
            <Sidebar account={props.account} />

            <div id="content" style={{ paddingBottom: "50px" }}>
                {/* {this.loadSnackbar()} */}
                <Navbar title={"List Prodi"} />
                {listError && <div role="alert" className="alert alert-warning">
                    {listError} <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => fetchUniqueListProdi(size, pages, listType, search)}>Coba lagi</button>
                </div>}
                {/* {this.modalCreateUpdate()} */}

                <Row style={{ marginBottom: 40 }}>
                    <Col sm={12}>
                        <Card style={{ padding: 20 }}>
                            <Row>
                                <Col sm={4}></Col>
                                <Col sm={4}>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Tipe</FormLabel>
                                    <RadioGroup row aria-label="demo-row-radio-buttons-group-label" name="listType" value={listType} onChange={handleSelectType} required>
                                        <FormControlLabel id="SNMPTN" value="SNMPTN" control={<Radio />} label="SNMPTN" />
                                        <FormControlLabel id="SBMPTN" value="SBMPTN" control={<Radio />} label="SBMPTN" />
                                    </RadioGroup>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                {listType !== null && (
                    <>
                        <Row>
                            <Col sm={7}></Col>
                            <Col align="right">
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Cari Kode Prodi</InputLabel>
                                    <Input onChange={handleChangeNamePp} placeholder="Cari Kode Prodi" id="namaProgram" endAdornment={<SearchIcon position="end" />} />
                                </FormControl>
                            </Col>
                        </Row>
                        <FunlistProdi />
                    </>
                )}
            </div>
            <Modal show={isOpen} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Program Studi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <Row style={{ marginBottom: 40 }}>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Kode Prodi</InputLabel>
                                    <Input onChange={(e) => setkodeProdi(e.target.value)} value={kodeProdi} placeholder="Kode Prodi" id="kodeProdi" readOnly disabled />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Nama Prodi Perguruan Tinggi</InputLabel>
                                    <Input onChange={(e) => setnamaProdiPtn(e.target.value)} value={namaProdiPtn} placeholder="Nama Prodi Perguruan Tinggi" id="namaProdiPtn" readOnly disabled />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Nama Prodi</InputLabel>
                                    <Input onChange={(e) => setnamaProdi(e.target.value)} value={namaProdi} placeholder="Nama Prodi" id="namaProdi" disabled />
                                </FormControl>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: 40 }}>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Jumlah Peminat</InputLabel>
                                    <Input onChange={(e) => setjumlahPeminat(e.target.value)} value={jumlahPeminat} placeholder="Jumlah Peminat" id="jumlahPeminat" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Daya Tampung Lama</InputLabel>
                                    <Input onChange={(e) => setdtLama(e.target.value)} value={dtLama} placeholder="Daya Tampung Lama" id="dtLama" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Daya Tampung Baru</InputLabel>
                                    <Input onChange={(e) => setdtBaru(e.target.value)} value={dtBaru} placeholder="Daya Tampung Baru" id="dtBaru" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Poin</InputLabel>
                                    <Input onChange={(e) => setpoin(e.target.value)} value={poin} placeholder="Poin" id="poin" />
                                </FormControl>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: 40 }}>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Index Ketetatan</InputLabel>
                                    <Input onChange={(e) => setindexKeketatan(e.target.value)} value={indexKeketatan} placeholder="Index Ketetatan" id="indexKeketatan" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Index Persaingan</InputLabel>
                                    <Input onChange={(e) => setindexPersaingan(e.target.value)} value={indexPersaingan} placeholder="Index Persaingan" id="indexPersaingan" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Kelompok Prodi</InputLabel>
                                    <Input onChange={(e) => setkelompokProdi(e.target.value)} value={kelompokProdi} placeholder="Kelompok Prodi" id="kelompokProdi" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Kategori PTN</InputLabel>
                                    <Input onChange={(e) => setkategoriPTN(e.target.value)} value={kategoriPTN} placeholder="Kategori PTN" id="kategoriPTN" />
                                </FormControl>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: 40 }}>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Nilai Nasional</InputLabel>
                                    <Input onChange={(e) => setnilaiNasional(e.target.value)} value={nilaiNasional} placeholder="Nilai Nasional" id="nilaiNasional" />
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl>
                                    <InputLabel htmlFor="standard-adornment-password">Nilai Rataan Minimum</InputLabel>
                                    <Input onChange={(e) => setnilaiRataanMinimum(e.target.value)} value={nilaiRataanMinimum} placeholder="Nilai Rataan Minimum" id="nilaiRataanMinimum" />
                                </FormControl>
                            </Col>
                            {listType === "SNMPTN" && (
                                <Col>
                                    <FormControl>
                                        <InputLabel htmlFor="standard-adornment-password">Nilai Rataan</InputLabel>
                                        <Input onChange={(e) => setnilaiRataan(e.target.value)} value={nilaiRataan} placeholder="Nilai Rataan" id="nilaiRataan" />
                                    </FormControl>
                                </Col>
                            )}
                        </Row>
                        {listType === "SNMPTN" && (
                            <>
                                <Row style={{ marginBottom: 40 }}>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Agama 1</InputLabel>
                                            <Input onChange={(e) => setmpkpAgama1(e.target.value)} value={mpkpAgama1} placeholder="MPKP Agama 1" id="mpkpAgama1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Agama 2</InputLabel>
                                            <Input onChange={(e) => setmpkpAgama2(e.target.value)} value={mpkpAgama2} placeholder="MPKP Agama 2" id="mpkpAgama2" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Akp 1</InputLabel>
                                            <Input onChange={(e) => setmpkpAkp1(e.target.value)} value={mpkpAkp1} placeholder="MPKP Akp 1" id="mpkpAkp1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Akp 2</InputLabel>
                                            <Input onChange={(e) => setmpkpAkp2(e.target.value)} value={mpkpAkp2} placeholder="MPKP Akp 2" id="mpkpAkp2" />
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 40 }}>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Asesmen 1</InputLabel>
                                            <Input onChange={(e) => setmpkpAsesmen1(e.target.value)} value={mpkpAsesmen1} placeholder="MPKP Asesmen 1" id="mpkpAsesmen1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Asesmen 2</InputLabel>
                                            <Input onChange={(e) => setmpkpAsesmen2(e.target.value)} value={mpkpAsesmen2} placeholder="MPKP Asesmen 2" id="mpkpAsesmen2" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Bahasa 1</InputLabel>
                                            <Input onChange={(e) => setmpkpBahasa1(e.target.value)} value={mpkpBahasa1} placeholder="MPKP Bahasa 1" id="mpkpBahasa1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Bahasa 2</InputLabel>
                                            <Input onChange={(e) => setmpkpBahasa2(e.target.value)} value={mpkpBahasa2} placeholder="MPKP Bahasa 2" id="mpkpBahasa2" />
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 40 }}>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Ipa 1</InputLabel>
                                            <Input onChange={(e) => setmpkpIpa1(e.target.value)} value={mpkpIpa1} placeholder="MPKP Ipa 1" id="mpkpIpa1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Ipa 2</InputLabel>
                                            <Input onChange={(e) => setmpkpIpa2(e.target.value)} value={mpkpIpa2} placeholder="MPKP Ipa 2" id="mpkpIpa2" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Ips 1</InputLabel>
                                            <Input onChange={(e) => setmpkpIps1(e.target.value)} value={mpkpIps1} placeholder="MPKP Ips 1" id="mpkpIps1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Ips 2</InputLabel>
                                            <Input onChange={(e) => setmpkpIps2(e.target.value)} value={mpkpIps2} placeholder="MPKP Ips 2" id="mpkpIps2" />
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: 40 }}>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Psp 1</InputLabel>
                                            <Input onChange={(e) => setmpkpPsp1(e.target.value)} value={mpkpPsp1} placeholder="MPKP Psp 1" id="mpkpPsp1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Psp 2</InputLabel>
                                            <Input onChange={(e) => setmpkpPsp2(e.target.value)} value={mpkpPsp2} placeholder="MPKP Psp 2" id="mpkpPsp2" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Tkp 1</InputLabel>
                                            <Input onChange={(e) => setmpkpTkp1(e.target.value)} value={mpkpTkp1} placeholder="MPKP Tkp 1" id="mpkpTkp1" />
                                        </FormControl>
                                    </Col>
                                    <Col>
                                        <FormControl>
                                            <InputLabel htmlFor="standard-adornment-password">MPKP Tkp 2</InputLabel>
                                            <Input onChange={(e) => setmpkpTkp2(e.target.value)} value={mpkpTkp2} placeholder="MPKP Tkp 2" id="mpkpTkp2" />
                                        </FormControl>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Grid item xs={12}>
                            <Button variant="outlined" color="secondary" style={{ float: "left" }} onClick={() => handleCloseModal()}>
                                <li className="fa fa-close"> Batal</li>
                            </Button>
                            <Button variant="outlined" color="primary" type="submit" style={{ float: "right" }}>
                                <li className="fa fa-save"> Simpan</li>
                            </Button>
                        </Grid>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={isOpenImport} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Import Program Studi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmitFile}>
                        <Row style={{ marginBottom: 40 }}>
                            <Col>
                                <input type="file" className="form-control" required onChange={onFileChange} id="file" accept=".xlsx" />
                            </Col>
                            <Col>
                                <h5>Prosedur Upload Prodi :</h5>
                                <ol>
                                    <li>Download format dokumen (.xlsx)&nbsp;</li>
                                    <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                                    <li>
                                        Format dokumen wajib &nbsp;
                                        <span class="text-danger">
                                            <strong>*</strong>
                                        </span>
                                        <strong>.xlsx</strong>
                                        <span class="text-danger">
                                            <strong>*</strong>
                                        </span>
                                    </li>
                                    <li>
                                        Prodi Akan di update berdasarkan <strong>KODE PRODI</strong> yang telah tersedia di system,
                                    </li>
                                    <li>KODE PRODI di sistem yang tidak sesuai dengan file upload akan otomatis terhapus</li>
                                    <li>PASTIKAN file yang akan di upload sudah sesuai dengan data terbaru.</li>
                                    <br />
                                    <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + "/Matcher_Nama_Prodi.xlsx"}>
                                        <li className="fa fa-download"> Download</li>
                                    </a>
                                </ol>
                            </Col>
                        </Row>
                        <Grid item xs={12}>
                            <Button variant="outlined" color="secondary" style={{ float: "left" }} onClick={() => handleCloseModalImport()}>
                                <li className="fa fa-close"> Batal</li>
                            </Button>
                            <Button variant="outlined" color="primary" type="submit" style={{ float: "right" }}>
                                <li className="fa fa-save"> Simpan</li>
                            </Button>
                        </Grid>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(ListProdi);
